// @flow
import * as React from 'react';
import {
  DataGrid,
  DataGridColumn,
  ListPageWrapper,
  PageTitle, useDeleteEmailTemplateMutation,
  useEmailTemplatesQuery
} from '../../shared';
import { Button, CircularProgress, IconButton, Typography } from '@mui/material';
import { useEmailTemplateForm, withEmailTemplateForm } from './email-template-form';
import { X } from '@phosphor-icons/react';
import { useConfirm } from '@coverright/features';
import { theme } from '../../app/theme';
import { EmailTemplateDto } from '@coverright/data-access/types/enrollment';

const List = () => {
  const {open} = useEmailTemplateForm()
  const {data, loading} = useEmailTemplatesQuery({
    variables: { pageInput: {page: 0, size: 1000} },
    fetchPolicy: "cache-and-network"
  })

  const rows = data?.emailTemplates.data || [];

  return (
    <ListPageWrapper>
      <PageTitle title="Email templates">
        <Button variant={'contained'} size={'small'} sx={{minWidth: 150, alignSelf: 'center'}} onClick={e => {
          open()
        }}>
          Create new template
        </Button>
      </PageTitle>

      <DataGrid columns={columns}
                page={0}
                hidePaginator
                rowsPerPage={1000}
                onRowClick={open}
                loading={loading}
                total={data?.emailTemplates.totalElements}
                rows={rows}  />
    </ListPageWrapper>

  );
};

export const EmailTemplates = withEmailTemplateForm(List);

const columns: DataGridColumn<EmailTemplateDto, keyof EmailTemplateDto>[] = [
  {
    title: 'Template name',
    value: v => v.title,
    width: 500
  },
  {
    title: 'Preview',
    value: v => <Typography sx={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 400}}>{v.template}</Typography>
  },
  {
    title: 'Delete',
    value: v => <DeleteButton template={v} />
  }
]

const DeleteButton = ({template}: {template: EmailTemplateDto}) => {
  const [remove, {loading}] = useDeleteEmailTemplateMutation({
    refetchQueries: ['emailTemplates']
  })
  const confirm = useConfirm(theme);

  const handleClick = () => {
    confirm({
      content: 'Are you sure you want to delete this template?',
      okButtonTitle: 'Yes',
      cancelButtonTitle: 'No',
      title: 'Attention!',
    })
      .then(val => {
        if (val) {
          remove({
            variables: {id: template.id},
          })
        }
      })
  }

  return <IconButton size={'small'} onClick={e => {
    e.stopPropagation();
    handleClick()
  }}>
    {!loading ? <X weight={'bold'} color={'red'} size={14} /> : <CircularProgress size={14} />}
  </IconButton>
}
